import { CTA, styled } from "@vw-marketing/us-components";

export const StyledManageContactsRemoveEmail: any = styled.div`
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    gap: ${({theme}) => theme.size.static350};
    height: 80svh;
    justify-content: space-between;
    margin-top: ${({ theme }) => theme.size.static400};
    align-self: stretch;
`;

export const StyledManageContactsRemoveEmailDescription: any = styled.div`
    display: flex;
    flex-direction: row;
    align-self: stretch;

    div, span {
        overflow: hidden;
        text-overflow: ellipsis; 
    } 
`;

export const StyledManageContactsRemoveEmailCTA: any = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${({theme}) => theme.size.static300};
    width: 100%;
`;


export const StyledManageContactsRemoveEmailCustomCTA: any = styled(CTA)`
    background: ${( props ) =>  props.theme.colors.signal.error };
`;